<template>
    <div v-if="isslide">
        <div class="container">
            <div class="campaign-list">
                <div v-if="isHaveItem" class="box-content">
                    <campaign-item
                        v-for="(campaign, k) in campaigns"
                        class="campaign-item"
                        :key="k"
                        :index="k"
                        :lbl="lbl"
                        :campaign="campaign"
                        :darkBG="true"
                        :square="square"
                        :isClickCampaign="isClickCampaign"
                        :isNews="isNews"
                    >
                    </campaign-item>
                </div>
                <div
                    v-if="isLoaded && !isHaveItem"
                    class="text-center mt-5 not-campaign"
                >
                    พบกันเร็วๆนี้
                </div>
            </div>
        </div>
    </div>
    <div v-else class="row campaign-list  pt-2 w-100 m-0 padding_bottom">
        <div v-if="isHaveItem" class="col-6 box-content">
            <campaign-item
                v-for="(campaign, k) in campaigns"
                class="col-6 campaign-item-col "
                :key="k"
                :index="k"
                :lbl="lbl"
                :campaign="campaign"
                :darkBG="false"
                :showPoint="true"
                :square="square"
                :isClickCampaign="isClickCampaign"
            >
            </campaign-item>
        </div>
        <div
            v-if="isLoaded && !isHaveItem"
            class="col-12 text-center mt-5 not-campaign"
        >
            พบกันเร็วๆนี้
        </div>
    </div>
</template>
<script>
// import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
//component
import CampaignItem from "./CampaignItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

import Mixin from "@/mixin/Mixin";
import CacheHelper from "@/helper/CacheHelper.js";

//modal
// import Modal from '@/components/Modal/Modal.vue';
/**
 * property
 * @property {object} lbl (require) Text for component.
 * @property {boolean} isLoading (require) Loading status.
 * @property {object} initListConfig (require) Configuration for call api.
 * @property {object} initFilterConfig (require) Filter configuration for call api.
 * @property {object} busEvent (require) Bus event for parent component.
 * method
 * @method getList Get list of campaign for api.
 * @method initialLoadMore Initial scroll event to load more campaign.
 * @method loadMore Load more campaigns.
 * utility
 * @method hideLoading Hide loading screen.
 * @method showLoading Show loading screen.
 * bus event.
 * @event switchLang Reinitial campaign list with new language setup.
 * @event reInitList Reinitail campaign list.
 * @event toggleLoading Toggle loading value.
 */
export default {
    name: "CampaignList",
    components: {
        CampaignItem
        // Modal
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        initListConfig: Object,
        initFilterConfig: Object,
        busEvent: Object,
        isslide: Boolean,
        isClickCampaign: Boolean,
        square: Boolean,
        isNews: Boolean
    },
    data: function() {
        return {
            campaigns: [],
            isLoaded: false,
            isHaveItem: false,
            listConfig: {},
            filterConfig: {},
            cacheHelper: new CacheHelper(),
            userLevel: ""

            // busModal: new Vue()
        };
    },
    mixins: [Mixin],
    mounted: function() {
        this.busEvent.$on("switchLang", this.switchLang);
    },
    created: function() {
        this.busEvent.$on("reInitList", this.reInitialList);
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;
        this.getUserlevel();

        // this.getList();
        window.addEventListener("scroll", this.initialSeeMore);
    },
    beforeDestroy: function() {
        window.removeEventListener("scroll", this.initialSeeMore);
    },
    methods: {
        //initial
        getUserlevel() {
            this.userLevel = String(
                this.cacheHelper.getCache("BzbsUser").userLevel
            );
        },
        initialSeeMore: function() {
            if (
                window.scrollY + window.innerHeight + 10 >=
                document.body.scrollHeight
            ) {
                this.loadMore();
            }
        },
        //event
        //method
        getList: function() {
            return new Promise(resolve => {
                var strBzbsToken = Account.getToken();
                BzbsCampaign.apiGetCampaign(
                    strBzbsToken,
                    this.listConfig,
                    this.filterConfig
                ).subscribe(
                    campaigns => {
                        const checkUserVisibility = campaigns.filter(item => {
                            if (!item.userVisibility) item.userVisibility = 0;
                            return item.userVisibility <= this.userLevel;
                        });
                        campaigns = checkUserVisibility;
                        // console.log(campaigns)

                        this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (
                            campaigns &&
                            campaigns.length < this.listConfig.defaultTopAmount
                        )
                            this.listConfig.isSeeMoreEnable = false;

                        //reinitialize list if no skip.
                        if (
                            this.listConfig.intSkip ==
                            this.listConfig.defaultTopAmount
                        )
                            this.campaigns = [];

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoaded = true;
                        this.isHaveItem =
                            this.campaigns.length > 0 ? true : false;
                        resolve(campaigns);
                    },
                    err => {
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.handleLoading(false);
                        this.hideLoading();
                        console.log(err);
                    }
                );
            });
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        resetLoaded: function() {
            this.campaigns = [];
            this.isLoaded = false;
            this.isHaveItem = false;
        },
        // reInitialList: function(data) {
        //     this.resetLoaded();
        //     this.listConfig = data.listConfig;
        //     this.filterConfig = data.filterConfig;

        //     this.getList();
        // },
        //utilities
        hideLoading: function() {
            this.toggleLoading(false);
            // this.busModal.$emit('hideLoadingModal', {});
        },
        showLoading: function() {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            // this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        //bus event
        switchLang: function() {
            this.resetLoaded();
            this.getList();
        },
        toggleLoading: function(isLoading) {
            this.$emit("toggleLoading", isLoading);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./campaignlist.scss";
.container {
    padding: 0;
    width: 100%;
    .campaign-list {
        position: relative;
        z-index: 1;
        display: flex;
        overflow-y: scroll;
        .box-content {
            .campaign-item {
                width: 80%;
                flex-shrink: 0;
                padding: 5px;
                padding-left: 15px;
            }
        }
    }
}
.padding_bottom {
    padding-bottom: 50px;
}
.campaign-item-col {
    padding: 8px !important;
}
.campaign-list::-webkit-scrollbar {
    display: none;
}
.text-center {
    width: 100%;
    text-align: center;
}
</style>
